import {POSITIONTARIFFASTART} from './PositionTariffaStartTypes'

export const changePositionTariffaStart = positionTariffaStart => {
    return {
        type: POSITIONTARIFFASTART,
        load: positionTariffaStart
    }
}

export const selectNewPositionTariffaStart = (positionTariffaStart) => {

    return (dispatch) => {
        dispatch(changePositionTariffaStart(positionTariffaStart))
    }

}